import React from "react";
import { render } from "react-dom";
import { Banner } from ".";
import { DesignContextProvider } from "Components/DesignContext";


export function init(model: Readonly<LSCommon.Service.LSWebUI.Models.XPP.XppLandingPageJsViewModel>, onClaim: () => void) {
   const bannerContainer = document.getElementById("cyp-banner-container");
   if (!bannerContainer) {
      return;
   }

   render(<DesignContextProvider name="primary">
      <Banner isClaimable={model.IsClaimable} onClaim={onClaim} />
   </DesignContextProvider>
      , bannerContainer);
}
